import React, { forwardRef } from 'react';
import type { ComponentProps } from 'react';
import { CircularProgress as CircularProgressMUI } from '@mui/material';

const sizes = {
  x5Small: 8,
  x4Small: 10,
  x3Small: 12,
  x2Small: 14,
  xSmall: 16,
  small: 18,
  medium: 20,
  large: 24,
  xLarge: 28,
  x2Large: 32,
  x3Large: 36,
  x4Large: 40,
  x5Large: 44,
  x6Large: 48,
  x7Large: 52,
  x8Large: 56,
  x9Large: 60,
} as const;

type SizeKey = keyof typeof sizes;
type MuiProps = ComponentProps<typeof CircularProgressMUI>;

type Props = Omit<MuiProps, 'size'> & {
  size?: MuiProps['size'] | SizeKey;
};

const CircularProgress = forwardRef<HTMLSpanElement, Props>((props, ref) => (
  <CircularProgressMUI
    {...props}
    size={typeof props.size === 'string' && props.size in sizes ? sizes[props.size as SizeKey] : props.size}
    ref={ref}
  />
));

CircularProgress.displayName = 'CircularProgress';

export default CircularProgress;
